import { Injectable } from '@angular/core';
import { Etapa } from '../models/etapa';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Cliente } from '../models/cliente';
import { EtapaPedido } from '../models/etapa-pedido';
import { EtapaPedidoLista } from '../models/etapa-pedido-lista';
import { Monitor } from '../models/monitor';
import { FilaTarefa } from '../models/filas/fila-tarefa';

@Injectable({
  providedIn: 'root'
})
export class EtapaService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  salvar(etapa) {
    return this.http.post(globals.apiUrl + '/api/Etapa/Salvar', etapa);
  }

  consultarParaFiltro() {
    return this.http.get<Etapa[]>(globals.apiUrl + '/api/Etapa/ListarParaFiltro');
  }

  consultarParaEscolher() {
    return this.http.get<Etapa[]>(globals.apiUrl + '/api/Etapa/ListarParaEscolher');
  }

  consultar() {
    return this.http.get<Etapa[]>(globals.apiUrl + '/api/Etapa/Listar');
  }

  consultarPorIdCupom(idCupom) {
    return this.http.get<Etapa[]>(globals.apiUrl + '/api/Etapa/ListarPorIdCupom',
      { params: new HttpParams().set('idCupom', idCupom) });
  }

  consultarPorTipoDeAcompanhamento(tipo) {
    return this.http.get<Etapa[]>(globals.apiUrl + '/api/Etapa/ListarPorTipoAcompanhamento',
      { params: new HttpParams().set('tipo', tipo) });
  }

  salvarHistorico(etapa) {
    return this.http.post(globals.apiUrl + '/api/Etapa/SalvarHistorico', etapa);
  }

  salvarHistoricoSimples(etapa) {
    return this.http.post(globals.apiUrl + '/api/Etapa/SalvarHistoricoSimples', etapa);
  }

  consultarHistoricoPorIdCupom(idCupom) {
    return this.http.get<EtapaPedidoLista[]>(globals.apiUrl + '/api/Etapa/ListarHistorico',
      { params: new HttpParams().set('idCupom', idCupom) });
  }

  consultarComMonitores() {
    return this.http.get<Monitor[]>(globals.apiUrl + '/api/Etapa/ListarComMonitores');
  }

  concluirFilaTarefa(idFilaTarefa, status) {
    return this.http.post<FilaTarefa>(globals.apiUrl + '/api/Etapa/ConcluirFilaTarefa', {},
      { params: new HttpParams().set('idFilaTarefa', idFilaTarefa).set('status', status) });
  }
}
